// This file is automatically generated. Do not edit manually.

import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ReclamationOperationApi {
	export async function markReclamationPlanned(args: { reclamationId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/markReclamationPlanned",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
			},
		});
		return response as void;
	}

	export async function revertMarkReclamationPlanned(args: { reclamationId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/revertMarkReclamationPlanned",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
			},
		});
		return response as void;
	}

	export async function releaseReclamation(args: {
		releaseTasks: boolean;
		reclamationId?: number | null | undefined;
		reclamationIds?: Array<number>;
		workerUserId?: number | null | undefined;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/releaseReclamation",
			method: "POST",
			data: {
				releaseTasks: args.releaseTasks,
				reclamationId: args.reclamationId,
				reclamationIds: args.reclamationIds,
				workerUserId: args.workerUserId,
			},
		});
		return response as void;
	}

	export async function markReclamationReadyForReview(args: {
		reclamationId?: number | null | undefined;
		reclamationIds?: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/markReclamationReadyForReview",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
				reclamationIds: args.reclamationIds,
			},
		});
		return response as void;
	}

	export async function revertMarkReclamationReadyForReview(args: { reclamationId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/revertMarkReclamationReadyForReview",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
			},
		});
		return response as void;
	}

	export async function closeReclamation(args: { reclamationId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/closeReclamation",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
			},
		});
		return response as void;
	}

	export async function revertCloseReclamation(args: { reclamationId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/revertCloseReclamation",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
			},
		});
		return response as void;
	}

	export async function printReclamation(args: { reclamationId: number }): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/printReclamation",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function deleteReclamation(args: { reclamationId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/deleteReclamation",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
			},
		});
		return response as void;
	}

	export async function connectToCustomerOrder(args: {
		reclamationId: number;
		customerOrderId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/connectToCustomerOrder",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
				customerOrderId: args.customerOrderId,
			},
		});
		return response as void;
	}

	export async function removeConnectionToCustomerOrder(args: {
		reclamationId: number;
		customerOrderId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/reclamations/removeConnectionToCustomerOrder",
			method: "POST",
			data: {
				reclamationId: args.reclamationId,
				customerOrderId: args.customerOrderId,
			},
		});
		return response as void;
	}
}
